<template>
  <v-btn
    @click="logInWithFacebook"
    class="mt-3"
    :color="extras.type === 'whatsapp' ? 'success' : 'primary'"
    outline
    ><v-icon>{{
      extras.type === "whatsapp" ? "mdi-whatsapp" : "mdi-facebook"
    }}</v-icon>
    {{ extras.buttonText || "Continue With Facebook" }}</v-btn
  >
</template>
<script>
import env from '../../../utils/env'
export default {
  name: "embeddedSignup",
  data() {
    return {
      config_id: "1191770312192282",
    };
  },
  props: {
    extras: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  async mounted() {
    window.addEventListener("message", this.sessionInfoListener);

    await this.loadFacebookSDK(document, "script", "facebook-jssdk");
  },
  methods: {
    async logInWithFacebook() {
      await this.initFbLogin();
      window.FB.login(
        (response) => {
          console.log(response);
          if (response.authResponse) {
            this.$emit("loginSuccess", response.authResponse);
          } else {
            this.$store.dispatch(
              "setErrorMessage",
              `Embedded Signup Cancelled`
            );
          }
        },
        {
          config_id: this.config_id,
          response_type: "code", // must be set to 'code' for System User access token
          override_default_response_type: true,
          extras: {
            sessionInfoVersion: 2,
            // feature: "whatsapp_embedded_signup",
            ...this.extras,
          },
        }
      );
      return false;
    },

    async initFbLogin() {
      window.FB.init({
        appId: env.FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v19.0",
      });
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    async sessionInfoListener(event) {
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }
      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
          // if user finishes the Embedded Signup flow
          if (data.event === "FINISH") {
            const { phone_number_id, waba_id } = data.data;
            this.$emit("WA_EMBEDDED_SIGNUP_FINISH", {
              phone_number_id,
              waba_id,
            });
          } else {
            // if user cancels the Embedded Signup flow
            const { current_step } = data.data;
            console.log(current_step);
          }
        }
      } catch {
        // Don’t parse info that’s not a JSON
        console.log("Non JSON Response", event.data);
      }
    },
  },
  watch: {},
};
</script>
<style>
.button {
  color: white;
  min-width: 150px;
  background-color: #000000a1;
  height: 2.5rem;
  border-radius: 2rem;
  font-weight: 400;
  font-size: 0.8rem;
}
</style>
